import { forwardRef } from "react";

import { NavLink, NavLinkProps } from "react-router-dom";

export const MuiTabNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
    (props, ref) => (
        <NavLink
            ref={ref}
            to={props.to}
            className={({ isActive }) =>
                `${props.className} ${isActive ? "Mui-selected" : ""}`
            }
        >
            {props.children}
        </NavLink>
    ),
);
